import React from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { Form } from 'antd'
import { UserActivityDto } from 'api/Identity/Types/UserActivityDto'
import { UserStatisticsDto } from 'api/Identity/Types/UserStatisticsDto'
import { PageData } from 'api/Pagination/Types'
import { FormBaseColumn, FormBaseRow } from 'components/Form/Form.styles'
import { formatLocalDateUTC } from 'utils/date'

import { FormFieldBlock, FormFieldGroup, FormFieldLabel } from '../Administration.styles'

interface Props {
  statistics: UserStatisticsDto | undefined
  userActivity: PageData<UserActivityDto[]> | undefined
}
const AddEditUserStatisticsForm: React.FC<Props> = ({ statistics, userActivity }) => {
  return (
    <FormBaseColumn style={{ width: '100%', margin: 0 }}>
      <Form>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Last Successful Login</FormFieldLabel>
            <FormFieldGroup>
              <input
                type='text'
                value={formatLocalDateUTC(statistics?.lastSuccessfulLogin, true) || ''}
                disabled
              />
            </FormFieldGroup>
          </FormBaseRow>
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Failed Login Attempts</FormFieldLabel>
            <FormFieldGroup>
              <input type='text' value={statistics?.failedLoginCount} disabled />
            </FormFieldGroup>
          </FormBaseRow>
        </FormFieldBlock>
      </Form>
      <Grid
        resizable
        data={userActivity ? userActivity.items : []}
        total={userActivity ? userActivity.totalResults : 0}
      >
        <Column
          title='Date'
          cell={(props: GridCellProps) => (
            <td className='table-columns__date'>
              {formatLocalDateUTC(props.dataItem.recordedOn, true)}
            </td>
          )}
        />
        <Column title='Type' field='type' />
        <Column title='IP Address' field='ipAddress' />
        <Column title='User-Agent' field='userAgent' />
      </Grid>
    </FormBaseColumn>
  )
}

export default AddEditUserStatisticsForm
